/// <reference path="./clientPoint.section.base.ts" />
module Meevo.Plugins.ClientPoint {
    "use strict";

    import PointAdjustmentTypeEnum = Meevo.Model.PointAdjustmentTypeEnum;
    import IClientPoint = Meevo.Model.IClientPoint;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import SecurityParts = Meevo.Components.Common.SecurityParts;

    interface IClientPointData {
        client_TId: Guid;
        pointsAmount: number;
        expireDate?: Date;
        pointAdjustmentTypeEnum: PointAdjustmentTypeEnum;
        adjustmentNote: string;
    }

    enum ActionTypeEnum {
        Add,
        Remove
    }

    /**
    * Main Section of Client Points Manager
    */
    export class MainSection extends Meevo.Plugins.ClientPoint.ClientPointSectionBase<IClientPoint> {
        public points: IClientPointData;
        public selectedActionType: ActionTypeEnum = ActionTypeEnum.Add;
        public dollarValue: number;
        public adjustedDollarValue: number;
        public todayDate: Date = new Date();
        public adjustmentForm:any;

        constructor(
            protected context: Meevo.Plugins.ClientPoint.ClientPointContext,
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected clientPointService: Meevo.Plugins.ClientPoint.IClientPointService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected modalService: Meevo.Components.Modal.IModalService,
            $rootScope: angular.IRootScopeService,
            sectionSecurityKey: string,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $q: angular.IQService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun,$rootScope,context, sectionSecurityKey);
        }

        activate() {
            this.points = {
                client_TId: this.model.client_TId,
                pointsAmount: 0,
                expireDate: null,
                pointAdjustmentTypeEnum: PointAdjustmentTypeEnum.Manual,
                adjustmentNote: ''
            }

            this.clientPointService.clientPoint = this.model;

            this.busyService.start();
            this.clientPointService.getSettings().finally(() => {
                this.busyService.stop();
            });
        }

        /**
         * Log Points
         */
        logPoints() {
            let postfix: string = '',
                pointsCopy: IClientPointData;

            if (!this.points.adjustmentNote || !this.points.pointsAmount) {
                return;
            }

            if (this.selectedActionType === ActionTypeEnum.Add && !this.points.expireDate) {
                return;
            }

            if (this.selectedActionType === ActionTypeEnum.Remove) {
                postfix = 'Disposition';
            }

            pointsCopy = angular.copy(this.points);
            pointsCopy.pointsAmount = this.dollarValue;

            this.busyService.start();
            return this.dataService.customMethodData(`api/ClientPoint/${postfix}`, 'POST', pointsCopy)
                .then(() => {
                    return this.clientPointService.getGeneralInformation().then((data: IClientPoint) => {
                        this.model = data;
                        this.points.expireDate = null;
                        this.points.pointsAmount = null;
                        this.pointsAmountChanged();
                        this.points.adjustmentNote = ''
                        this.selectedActionType = ActionTypeEnum.Add;
                        return this.$q.resolve();
                    });
                })
                .catch((error) => {
                    this.modalService
                        .alert(error.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                })
                .finally(() => {
                    this.busyService.stop();
                });;
        }

        /**
         * User enters amount of points
         */
        pointsAmountChanged(): void {
            this.dollarValue = this.clientPointService.convertPointsToDollarValue(this.points.pointsAmount, true);
            this.adjustedDollarValue = this.clientPointService.convertPointsToDollarValue(this.points.pointsAmount, false);
        }

        get actionTypeEnum(): any {
            return ActionTypeEnum;
        }

        usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum): void {
            let trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, this.parentItemId);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

        init(form) {
            this.adjustmentForm = form;
        }
        rollbackChanges(): void {
            _.extend(this.model, this.originalEntity);

            this.postCancel();
        }

        public postCancel(): void {
            this.points = {
                client_TId: this.model.client_TId,
                pointsAmount: 0,
                expireDate: null,
                pointAdjustmentTypeEnum: PointAdjustmentTypeEnum.Manual,
                adjustmentNote: ''
            }
        }
    }
}